



















































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';
import { EditorMenuBar } from 'tiptap';

@Component({
  components: {
    EditorMenuBar,
  },
})
export default class TextToolbar extends Vue {
  @Prop(Object) editor!: unknown;
  @Prop(Boolean) isShared!: boolean;
  @Prop(Boolean) isLocked!: boolean;
  @Prop(Boolean) isUsed!: boolean;
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];

  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  activeHelper: 'style' | 'format' | 'list' | null = null;

  setActiveHelper(type: 'style' | 'format' | 'list') {
    this.activeHelper = this.activeHelper === type ? null : type;
  }

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }

  async share() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        shared: !(this.selectedElement.data as { shared: boolean }).shared,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }

  async unlock() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }
}
